
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
// packages/alpinejs/src/scheduler.js
var $1995762e80cda67d$var$flushPending = false;
var $1995762e80cda67d$var$flushing = false;
var $1995762e80cda67d$var$queue = [];
var $1995762e80cda67d$var$lastFlushedIndex = -1;
var $1995762e80cda67d$var$transactionActive = false;
function $1995762e80cda67d$var$scheduler(callback) {
    $1995762e80cda67d$var$queueJob(callback);
}
function $1995762e80cda67d$var$startTransaction() {
    $1995762e80cda67d$var$transactionActive = true;
}
function $1995762e80cda67d$var$commitTransaction() {
    $1995762e80cda67d$var$transactionActive = false;
    $1995762e80cda67d$var$queueFlush();
}
function $1995762e80cda67d$var$queueJob(job) {
    if (!$1995762e80cda67d$var$queue.includes(job)) $1995762e80cda67d$var$queue.push(job);
    $1995762e80cda67d$var$queueFlush();
}
function $1995762e80cda67d$var$dequeueJob(job) {
    let index = $1995762e80cda67d$var$queue.indexOf(job);
    if (index !== -1 && index > $1995762e80cda67d$var$lastFlushedIndex) $1995762e80cda67d$var$queue.splice(index, 1);
}
function $1995762e80cda67d$var$queueFlush() {
    if (!$1995762e80cda67d$var$flushing && !$1995762e80cda67d$var$flushPending) {
        if ($1995762e80cda67d$var$transactionActive) return;
        $1995762e80cda67d$var$flushPending = true;
        queueMicrotask($1995762e80cda67d$var$flushJobs);
    }
}
function $1995762e80cda67d$var$flushJobs() {
    $1995762e80cda67d$var$flushPending = false;
    $1995762e80cda67d$var$flushing = true;
    for(let i = 0; i < $1995762e80cda67d$var$queue.length; i++){
        $1995762e80cda67d$var$queue[i]();
        $1995762e80cda67d$var$lastFlushedIndex = i;
    }
    $1995762e80cda67d$var$queue.length = 0;
    $1995762e80cda67d$var$lastFlushedIndex = -1;
    $1995762e80cda67d$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $1995762e80cda67d$var$reactive;
var $1995762e80cda67d$var$effect;
var $1995762e80cda67d$var$release;
var $1995762e80cda67d$var$raw;
var $1995762e80cda67d$var$shouldSchedule = true;
function $1995762e80cda67d$var$disableEffectScheduling(callback) {
    $1995762e80cda67d$var$shouldSchedule = false;
    callback();
    $1995762e80cda67d$var$shouldSchedule = true;
}
function $1995762e80cda67d$var$setReactivityEngine(engine) {
    $1995762e80cda67d$var$reactive = engine.reactive;
    $1995762e80cda67d$var$release = engine.release;
    $1995762e80cda67d$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($1995762e80cda67d$var$shouldSchedule) $1995762e80cda67d$var$scheduler(task);
                else task();
            }
        });
    $1995762e80cda67d$var$raw = engine.raw;
}
function $1995762e80cda67d$var$overrideEffect(override) {
    $1995762e80cda67d$var$effect = override;
}
function $1995762e80cda67d$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $1995762e80cda67d$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $1995762e80cda67d$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
function $1995762e80cda67d$var$watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let oldValueJSON;
    let effectReference = $1995762e80cda67d$var$effect(()=>{
        let value = getter();
        let newJSON = JSON.stringify(value);
        if (!firstTime) {
            if (typeof value === "object" || value !== oldValue) {
                let previousValue = typeof oldValue === "object" ? JSON.parse(oldValueJSON) : oldValue;
                queueMicrotask(()=>{
                    callback(value, previousValue);
                });
            }
        }
        oldValue = value;
        oldValueJSON = newJSON;
        firstTime = false;
    });
    return ()=>$1995762e80cda67d$var$release(effectReference);
}
async function $1995762e80cda67d$var$transaction(callback) {
    $1995762e80cda67d$var$startTransaction();
    try {
        await callback();
        await Promise.resolve();
    } finally{
        $1995762e80cda67d$var$commitTransaction();
    }
}
// packages/alpinejs/src/mutation.js
var $1995762e80cda67d$var$onAttributeAddeds = [];
var $1995762e80cda67d$var$onElRemoveds = [];
var $1995762e80cda67d$var$onElAddeds = [];
function $1995762e80cda67d$var$onElAdded(callback) {
    $1995762e80cda67d$var$onElAddeds.push(callback);
}
function $1995762e80cda67d$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $1995762e80cda67d$var$onElRemoveds.push(callback);
    }
}
function $1995762e80cda67d$var$onAttributesAdded(callback) {
    $1995762e80cda67d$var$onAttributeAddeds.push(callback);
}
function $1995762e80cda67d$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $1995762e80cda67d$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $1995762e80cda67d$var$cleanupElement(el) {
    el._x_effects?.forEach($1995762e80cda67d$var$dequeueJob);
    while(el._x_cleanups?.length)el._x_cleanups.pop()();
}
var $1995762e80cda67d$var$observer = new MutationObserver($1995762e80cda67d$var$onMutate);
var $1995762e80cda67d$var$currentlyObserving = false;
function $1995762e80cda67d$var$startObservingMutations() {
    $1995762e80cda67d$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $1995762e80cda67d$var$currentlyObserving = true;
}
function $1995762e80cda67d$var$stopObservingMutations() {
    $1995762e80cda67d$var$flushObserver();
    $1995762e80cda67d$var$observer.disconnect();
    $1995762e80cda67d$var$currentlyObserving = false;
}
var $1995762e80cda67d$var$queuedMutations = [];
function $1995762e80cda67d$var$flushObserver() {
    let records = $1995762e80cda67d$var$observer.takeRecords();
    $1995762e80cda67d$var$queuedMutations.push(()=>records.length > 0 && $1995762e80cda67d$var$onMutate(records));
    let queueLengthWhenTriggered = $1995762e80cda67d$var$queuedMutations.length;
    queueMicrotask(()=>{
        if ($1995762e80cda67d$var$queuedMutations.length === queueLengthWhenTriggered) while($1995762e80cda67d$var$queuedMutations.length > 0)$1995762e80cda67d$var$queuedMutations.shift()();
    });
}
function $1995762e80cda67d$var$mutateDom(callback) {
    if (!$1995762e80cda67d$var$currentlyObserving) return callback();
    $1995762e80cda67d$var$stopObservingMutations();
    let result = callback();
    $1995762e80cda67d$var$startObservingMutations();
    return result;
}
var $1995762e80cda67d$var$isCollecting = false;
var $1995762e80cda67d$var$deferredMutations = [];
function $1995762e80cda67d$var$deferMutations() {
    $1995762e80cda67d$var$isCollecting = true;
}
function $1995762e80cda67d$var$flushAndStopDeferringMutations() {
    $1995762e80cda67d$var$isCollecting = false;
    $1995762e80cda67d$var$onMutate($1995762e80cda67d$var$deferredMutations);
    $1995762e80cda67d$var$deferredMutations = [];
}
function $1995762e80cda67d$var$onMutate(mutations) {
    if ($1995762e80cda67d$var$isCollecting) {
        $1995762e80cda67d$var$deferredMutations = $1995762e80cda67d$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = [];
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].removedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (!node._x_marker) return;
                removedNodes.add(node);
            });
            mutations[i].addedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (removedNodes.has(node)) {
                    removedNodes.delete(node);
                    return;
                }
                if (node._x_marker) return;
                addedNodes.push(node);
            });
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $1995762e80cda67d$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $1995762e80cda67d$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.some((i)=>i.contains(node))) continue;
        $1995762e80cda67d$var$onElRemoveds.forEach((i)=>i(node));
    }
    for (let node of addedNodes){
        if (!node.isConnected) continue;
        $1995762e80cda67d$var$onElAddeds.forEach((i)=>i(node));
    }
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $1995762e80cda67d$var$scope(node) {
    return $1995762e80cda67d$var$mergeProxies($1995762e80cda67d$var$closestDataStack(node));
}
function $1995762e80cda67d$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$1995762e80cda67d$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $1995762e80cda67d$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $1995762e80cda67d$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $1995762e80cda67d$var$closestDataStack(node.parentNode);
}
function $1995762e80cda67d$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $1995762e80cda67d$var$mergeProxyTrap);
}
function $1995762e80cda67d$var$keyInPrototypeChain(obj, key) {
    if (obj === null || obj === Object.prototype) return null;
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj;
    return $1995762e80cda67d$var$keyInPrototypeChain(Object.getPrototypeOf(obj), key);
}
var $1995762e80cda67d$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $1995762e80cda67d$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Reflect.has(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        let target;
        for (const obj of objects){
            target = $1995762e80cda67d$var$keyInPrototypeChain(obj, name);
            if (target) break;
        }
        if (!target) target = objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return descriptor.set.call(thisProxy, value) || true;
        return Reflect.set(target, name, value);
    }
};
function $1995762e80cda67d$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $1995762e80cda67d$var$initInterceptors(data2) {
    let isObject3 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            if (typeof value === "object" && value !== null && value.__v_skip) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject3(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $1995762e80cda67d$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$1995762e80cda67d$var$get(data2, path), (value)=>$1995762e80cda67d$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $1995762e80cda67d$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $1995762e80cda67d$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $1995762e80cda67d$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $1995762e80cda67d$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $1995762e80cda67d$var$magics = {};
function $1995762e80cda67d$var$magic(name, callback) {
    $1995762e80cda67d$var$magics[name] = callback;
}
function $1995762e80cda67d$var$injectMagics(obj, el) {
    let memoizedUtilities = $1995762e80cda67d$var$getUtilities(el);
    Object.entries($1995762e80cda67d$var$magics).forEach(([name, callback])=>{
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, memoizedUtilities);
            },
            enumerable: false
        });
    });
    return obj;
}
function $1995762e80cda67d$var$getUtilities(el) {
    let [utilities, cleanup2] = $1995762e80cda67d$var$getElementBoundUtilities(el);
    let utils = {
        interceptor: $1995762e80cda67d$var$interceptor,
        ...utilities
    };
    $1995762e80cda67d$var$onElRemoved(el, cleanup2);
    return utils;
}
// packages/alpinejs/src/utils/error.js
function $1995762e80cda67d$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $1995762e80cda67d$var$handleError(e, el, expression);
    }
}
function $1995762e80cda67d$var$handleError(...args) {
    return $1995762e80cda67d$var$errorHandler(...args);
}
var $1995762e80cda67d$var$errorHandler = $1995762e80cda67d$var$normalErrorHandler;
function $1995762e80cda67d$var$setErrorHandler(handler4) {
    $1995762e80cda67d$var$errorHandler = handler4;
}
function $1995762e80cda67d$var$normalErrorHandler(error2, el, expression) {
    error2 = Object.assign(error2 ?? {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $1995762e80cda67d$var$shouldAutoEvaluateFunctions = true;
function $1995762e80cda67d$var$dontAutoEvaluateFunctions(callback) {
    let cache = $1995762e80cda67d$var$shouldAutoEvaluateFunctions;
    $1995762e80cda67d$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $1995762e80cda67d$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $1995762e80cda67d$var$evaluate(el, expression, extras = {}) {
    let result;
    $1995762e80cda67d$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $1995762e80cda67d$var$evaluateLater(...args) {
    return $1995762e80cda67d$var$theEvaluatorFunction(...args);
}
var $1995762e80cda67d$var$theEvaluatorFunction = ()=>{};
function $1995762e80cda67d$var$setEvaluator(newEvaluator) {
    $1995762e80cda67d$var$theEvaluatorFunction = newEvaluator;
}
var $1995762e80cda67d$var$theRawEvaluatorFunction;
function $1995762e80cda67d$var$setRawEvaluator(newEvaluator) {
    $1995762e80cda67d$var$theRawEvaluatorFunction = newEvaluator;
}
function $1995762e80cda67d$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $1995762e80cda67d$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$1995762e80cda67d$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $1995762e80cda67d$var$generateEvaluatorFromFunction(dataStack, expression) : $1995762e80cda67d$var$generateEvaluatorFromString(dataStack, expression, el);
    return $1995762e80cda67d$var$tryCatch.bind(null, el, expression, evaluator);
}
function $1995762e80cda67d$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [], context: context } = {})=>{
        if (!$1995762e80cda67d$var$shouldAutoEvaluateFunctions) {
            $1995762e80cda67d$var$runIfTypeOfFunction(receiver, func, $1995762e80cda67d$var$mergeProxies([
                scope2,
                ...dataStack
            ]), params);
            return;
        }
        let result = func.apply($1995762e80cda67d$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $1995762e80cda67d$var$runIfTypeOfFunction(receiver, result);
    };
}
var $1995762e80cda67d$var$evaluatorMemo = {};
function $1995762e80cda67d$var$generateFunctionFromString(expression, el) {
    if ($1995762e80cda67d$var$evaluatorMemo[expression]) return $1995762e80cda67d$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $1995762e80cda67d$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $1995762e80cda67d$var$evaluatorMemo[expression] = func;
    return func;
}
function $1995762e80cda67d$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $1995762e80cda67d$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [], context: context } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $1995762e80cda67d$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func.call(context, func, completeScope).catch((error2)=>$1995762e80cda67d$var$handleError(error2, el, expression));
            if (func.finished) {
                $1995762e80cda67d$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $1995762e80cda67d$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$1995762e80cda67d$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $1995762e80cda67d$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($1995762e80cda67d$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$1995762e80cda67d$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$1995762e80cda67d$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
function $1995762e80cda67d$var$evaluateRaw(...args) {
    return $1995762e80cda67d$var$theRawEvaluatorFunction(...args);
}
function $1995762e80cda67d$var$normalRawEvaluator(el, expression, extras = {}) {
    let overriddenMagics = {};
    $1995762e80cda67d$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$1995762e80cda67d$var$closestDataStack(el)
    ];
    let scope2 = $1995762e80cda67d$var$mergeProxies([
        extras.scope ?? {},
        ...dataStack
    ]);
    let params = extras.params ?? [];
    if (expression.includes("await")) {
        let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
        let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
        let func = new AsyncFunction([
            "scope"
        ], `with (scope) { let __result = ${rightSideSafeExpression}; return __result }`);
        let result = func.call(extras.context, scope2);
        return result;
    } else {
        let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(()=>{ ${expression} })()` : expression;
        let func = new Function([
            "scope"
        ], `with (scope) { let __result = ${rightSideSafeExpression}; return __result }`);
        let result = func.call(extras.context, scope2);
        if (typeof result === "function" && $1995762e80cda67d$var$shouldAutoEvaluateFunctions) return result.apply(scope2, params);
        return result;
    }
}
// packages/alpinejs/src/directives.js
var $1995762e80cda67d$var$prefixAsString = "x-";
function $1995762e80cda67d$var$prefix(subject = "") {
    return $1995762e80cda67d$var$prefixAsString + subject;
}
function $1995762e80cda67d$var$setPrefix(newPrefix) {
    $1995762e80cda67d$var$prefixAsString = newPrefix;
}
var $1995762e80cda67d$var$directiveHandlers = {};
function $1995762e80cda67d$var$directive(name, callback) {
    $1995762e80cda67d$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$1995762e80cda67d$var$directiveHandlers[directive2]) {
                console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
                return;
            }
            const pos = $1995762e80cda67d$var$directiveOrder.indexOf(directive2);
            $1995762e80cda67d$var$directiveOrder.splice(pos >= 0 ? pos : $1995762e80cda67d$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $1995762e80cda67d$var$directiveExists(name) {
    return Object.keys($1995762e80cda67d$var$directiveHandlers).includes(name);
}
function $1995762e80cda67d$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $1995762e80cda67d$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($1995762e80cda67d$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($1995762e80cda67d$var$outNonAlpineAttributes).map($1995762e80cda67d$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($1995762e80cda67d$var$byPriority);
    return directives2.map((directive2)=>{
        return $1995762e80cda67d$var$getDirectiveHandler(el, directive2);
    });
}
function $1995762e80cda67d$var$attributesOnly(attributes) {
    return Array.from(attributes).map($1995762e80cda67d$var$toTransformedAttributes()).filter((attr)=>!$1995762e80cda67d$var$outNonAlpineAttributes(attr));
}
var $1995762e80cda67d$var$isDeferringHandlers = false;
var $1995762e80cda67d$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $1995762e80cda67d$var$currentHandlerStackKey = Symbol();
function $1995762e80cda67d$var$deferHandlingDirectives(callback) {
    $1995762e80cda67d$var$isDeferringHandlers = true;
    let key = Symbol();
    $1995762e80cda67d$var$currentHandlerStackKey = key;
    $1995762e80cda67d$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($1995762e80cda67d$var$directiveHandlerStacks.get(key).length)$1995762e80cda67d$var$directiveHandlerStacks.get(key).shift()();
        $1995762e80cda67d$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $1995762e80cda67d$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $1995762e80cda67d$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $1995762e80cda67d$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $1995762e80cda67d$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $1995762e80cda67d$var$evaluateLater.bind($1995762e80cda67d$var$evaluateLater, el),
        evaluate: $1995762e80cda67d$var$evaluate.bind($1995762e80cda67d$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $1995762e80cda67d$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $1995762e80cda67d$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $1995762e80cda67d$var$getElementBoundUtilities(el);
    $1995762e80cda67d$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $1995762e80cda67d$var$isDeferringHandlers ? $1995762e80cda67d$var$directiveHandlerStacks.get($1995762e80cda67d$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $1995762e80cda67d$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $1995762e80cda67d$var$into = (i)=>i;
function $1995762e80cda67d$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $1995762e80cda67d$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $1995762e80cda67d$var$attributeTransformers = [];
function $1995762e80cda67d$var$mapAttributes(callback) {
    $1995762e80cda67d$var$attributeTransformers.push(callback);
}
function $1995762e80cda67d$var$outNonAlpineAttributes({ name: name }) {
    return $1995762e80cda67d$var$alpineAttributeRegex().test(name);
}
var $1995762e80cda67d$var$alpineAttributeRegex = ()=>new RegExp(`^${$1995762e80cda67d$var$prefixAsString}([^:^.]+)\\b`);
function $1995762e80cda67d$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        if (name === value) value = "";
        let typeMatch = name.match($1995762e80cda67d$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $1995762e80cda67d$var$DEFAULT = "DEFAULT";
var $1995762e80cda67d$var$directiveOrder = [
    "ignore",
    "ref",
    "id",
    "data",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $1995762e80cda67d$var$DEFAULT,
    "teleport"
];
function $1995762e80cda67d$var$byPriority(a, b) {
    let typeA = $1995762e80cda67d$var$directiveOrder.indexOf(a.type) === -1 ? $1995762e80cda67d$var$DEFAULT : a.type;
    let typeB = $1995762e80cda67d$var$directiveOrder.indexOf(b.type) === -1 ? $1995762e80cda67d$var$DEFAULT : b.type;
    return $1995762e80cda67d$var$directiveOrder.indexOf(typeA) - $1995762e80cda67d$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/dispatch.js
function $1995762e80cda67d$var$dispatch(el, name, detail = {}, options = {}) {
    return el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true,
        // Allows overriding the default event options.
        ...options
    }));
}
// packages/alpinejs/src/utils/walk.js
function $1995762e80cda67d$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$1995762e80cda67d$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $1995762e80cda67d$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $1995762e80cda67d$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $1995762e80cda67d$var$started = false;
function $1995762e80cda67d$var$start() {
    if ($1995762e80cda67d$var$started) $1995762e80cda67d$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $1995762e80cda67d$var$started = true;
    if (!document.body) $1995762e80cda67d$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $1995762e80cda67d$var$dispatch(document, "alpine:init");
    $1995762e80cda67d$var$dispatch(document, "alpine:initializing");
    $1995762e80cda67d$var$startObservingMutations();
    $1995762e80cda67d$var$onElAdded((el)=>$1995762e80cda67d$var$initTree(el, $1995762e80cda67d$var$walk));
    $1995762e80cda67d$var$onElRemoved((el)=>$1995762e80cda67d$var$destroyTree(el));
    $1995762e80cda67d$var$onAttributesAdded((el, attrs)=>{
        $1995762e80cda67d$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$1995762e80cda67d$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($1995762e80cda67d$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $1995762e80cda67d$var$initTree(el);
    });
    $1995762e80cda67d$var$dispatch(document, "alpine:initialized");
    setTimeout(()=>{
        $1995762e80cda67d$var$warnAboutMissingPlugins();
    });
}
var $1995762e80cda67d$var$rootSelectorCallbacks = [];
var $1995762e80cda67d$var$initSelectorCallbacks = [];
function $1995762e80cda67d$var$rootSelectors() {
    return $1995762e80cda67d$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $1995762e80cda67d$var$allSelectors() {
    return $1995762e80cda67d$var$rootSelectorCallbacks.concat($1995762e80cda67d$var$initSelectorCallbacks).map((fn)=>fn());
}
function $1995762e80cda67d$var$addRootSelector(selectorCallback) {
    $1995762e80cda67d$var$rootSelectorCallbacks.push(selectorCallback);
}
function $1995762e80cda67d$var$addInitSelector(selectorCallback) {
    $1995762e80cda67d$var$initSelectorCallbacks.push(selectorCallback);
}
function $1995762e80cda67d$var$closestRoot(el, includeInitSelectors = false) {
    return $1995762e80cda67d$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $1995762e80cda67d$var$allSelectors() : $1995762e80cda67d$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $1995762e80cda67d$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) return $1995762e80cda67d$var$findClosest(el._x_teleportBack, callback);
    if (el.parentNode instanceof ShadowRoot) return $1995762e80cda67d$var$findClosest(el.parentNode.host, callback);
    if (!el.parentElement) return;
    return $1995762e80cda67d$var$findClosest(el.parentElement, callback);
}
function $1995762e80cda67d$var$isRoot(el) {
    return $1995762e80cda67d$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $1995762e80cda67d$var$initInterceptors2 = [];
function $1995762e80cda67d$var$interceptInit(callback) {
    $1995762e80cda67d$var$initInterceptors2.push(callback);
}
var $1995762e80cda67d$var$markerDispenser = 1;
function $1995762e80cda67d$var$initTree(el, walker = $1995762e80cda67d$var$walk, intercept = ()=>{}) {
    if ($1995762e80cda67d$var$findClosest(el, (i)=>i._x_ignore)) return;
    $1995762e80cda67d$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            if (el2._x_marker) return;
            intercept(el2, skip);
            $1995762e80cda67d$var$initInterceptors2.forEach((i)=>i(el2, skip));
            $1995762e80cda67d$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            if (!el2._x_ignore) el2._x_marker = $1995762e80cda67d$var$markerDispenser++;
            el2._x_ignore && skip();
        });
    });
}
function $1995762e80cda67d$var$destroyTree(root, walker = $1995762e80cda67d$var$walk) {
    walker(root, (el)=>{
        $1995762e80cda67d$var$cleanupElement(el);
        $1995762e80cda67d$var$cleanupAttributes(el);
        delete el._x_marker;
    });
}
function $1995762e80cda67d$var$warnAboutMissingPlugins() {
    let pluginDirectives = [
        [
            "ui",
            "dialog",
            [
                "[x-dialog], [x-popover]"
            ]
        ],
        [
            "anchor",
            "anchor",
            [
                "[x-anchor]"
            ]
        ],
        [
            "sort",
            "sort",
            [
                "[x-sort]"
            ]
        ]
    ];
    pluginDirectives.forEach(([plugin2, directive2, selectors])=>{
        if ($1995762e80cda67d$var$directiveExists(directive2)) return;
        selectors.some((selector)=>{
            if (document.querySelector(selector)) {
                $1995762e80cda67d$var$warn(`found "${selector}", but missing ${plugin2} plugin`);
                return true;
            }
        });
    });
}
// packages/alpinejs/src/nextTick.js
var $1995762e80cda67d$var$tickStack = [];
var $1995762e80cda67d$var$isHolding = false;
function $1995762e80cda67d$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $1995762e80cda67d$var$isHolding || setTimeout(()=>{
            $1995762e80cda67d$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $1995762e80cda67d$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $1995762e80cda67d$var$releaseNextTicks() {
    $1995762e80cda67d$var$isHolding = false;
    while($1995762e80cda67d$var$tickStack.length)$1995762e80cda67d$var$tickStack.shift()();
}
function $1995762e80cda67d$var$holdNextTicks() {
    $1995762e80cda67d$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $1995762e80cda67d$var$setClasses(el, value) {
    if (Array.isArray(value)) return $1995762e80cda67d$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $1995762e80cda67d$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $1995762e80cda67d$var$setClasses(el, value());
    return $1995762e80cda67d$var$setClassesFromString(el, value);
}
function $1995762e80cda67d$var$splitClasses(classString) {
    return classString.split(/\s/).filter(Boolean);
}
function $1995762e80cda67d$var$setClassesFromString(el, classString) {
    let missingClasses = (classString2)=>$1995762e80cda67d$var$splitClasses(classString2).filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $1995762e80cda67d$var$setClassesFromObject(el, classObject) {
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? $1995762e80cda67d$var$splitClasses(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? $1995762e80cda67d$var$splitClasses(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $1995762e80cda67d$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $1995762e80cda67d$var$setStylesFromObject(el, value);
    return $1995762e80cda67d$var$setStylesFromString(el, value);
}
function $1995762e80cda67d$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $1995762e80cda67d$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $1995762e80cda67d$var$setStyles(el, previousStyles);
    };
}
function $1995762e80cda67d$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $1995762e80cda67d$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $1995762e80cda67d$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$1995762e80cda67d$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $1995762e80cda67d$var$registerTransitionsFromHelper(el, modifiers, value);
    else $1995762e80cda67d$var$registerTransitionsFromClassString(el, expression, value);
});
function $1995762e80cda67d$var$registerTransitionsFromClassString(el, classString, stage) {
    $1995762e80cda67d$var$registerTransitionObject(el, $1995762e80cda67d$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $1995762e80cda67d$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $1995762e80cda67d$var$registerTransitionObject(el, $1995762e80cda67d$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $1995762e80cda67d$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $1995762e80cda67d$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $1995762e80cda67d$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $1995762e80cda67d$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $1995762e80cda67d$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $1995762e80cda67d$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $1995762e80cda67d$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $1995762e80cda67d$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $1995762e80cda67d$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i?.());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $1995762e80cda67d$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $1995762e80cda67d$var$closestHide(parent);
}
function $1995762e80cda67d$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $1995762e80cda67d$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $1995762e80cda67d$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $1995762e80cda67d$var$once(()=>{
        $1995762e80cda67d$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $1995762e80cda67d$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $1995762e80cda67d$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $1995762e80cda67d$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $1995762e80cda67d$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $1995762e80cda67d$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $1995762e80cda67d$var$mutateDom(()=>{
                stages.end();
            });
            $1995762e80cda67d$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $1995762e80cda67d$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $1995762e80cda67d$var$isCloning = false;
function $1995762e80cda67d$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$1995762e80cda67d$var$isCloning ? fallback(...args) : callback(...args);
}
function $1995762e80cda67d$var$onlyDuringClone(callback) {
    return (...args)=>$1995762e80cda67d$var$isCloning && callback(...args);
}
var $1995762e80cda67d$var$interceptors = [];
function $1995762e80cda67d$var$interceptClone(callback) {
    $1995762e80cda67d$var$interceptors.push(callback);
}
function $1995762e80cda67d$var$cloneNode(from, to) {
    $1995762e80cda67d$var$interceptors.forEach((i)=>i(from, to));
    $1995762e80cda67d$var$isCloning = true;
    $1995762e80cda67d$var$dontRegisterReactiveSideEffects(()=>{
        $1995762e80cda67d$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $1995762e80cda67d$var$isCloning = false;
}
var $1995762e80cda67d$var$isCloningLegacy = false;
function $1995762e80cda67d$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $1995762e80cda67d$var$isCloning = true;
    $1995762e80cda67d$var$isCloningLegacy = true;
    $1995762e80cda67d$var$dontRegisterReactiveSideEffects(()=>{
        $1995762e80cda67d$var$cloneTree(newEl);
    });
    $1995762e80cda67d$var$isCloning = false;
    $1995762e80cda67d$var$isCloningLegacy = false;
}
function $1995762e80cda67d$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $1995762e80cda67d$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $1995762e80cda67d$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $1995762e80cda67d$var$initTree(el, shallowWalker);
}
function $1995762e80cda67d$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $1995762e80cda67d$var$effect;
    $1995762e80cda67d$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $1995762e80cda67d$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $1995762e80cda67d$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $1995762e80cda67d$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $1995762e80cda67d$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $1995762e80cda67d$var$camelCase(name) : name;
    switch(name){
        case "value":
            $1995762e80cda67d$var$bindInputValue(el, value);
            break;
        case "style":
            $1995762e80cda67d$var$bindStyles(el, value);
            break;
        case "class":
            $1995762e80cda67d$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $1995762e80cda67d$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $1995762e80cda67d$var$bindAttribute(el, name, value);
            break;
    }
}
function $1995762e80cda67d$var$bindInputValue(el, value) {
    if ($1995762e80cda67d$var$isRadio(el)) {
        if (el.attributes.value === void 0) el.value = value;
    } else if ($1995762e80cda67d$var$isCheckbox(el)) {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$1995762e80cda67d$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $1995762e80cda67d$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $1995762e80cda67d$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $1995762e80cda67d$var$setClasses(el, value);
}
function $1995762e80cda67d$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $1995762e80cda67d$var$setStyles(el, value);
}
function $1995762e80cda67d$var$bindAttributeAndProperty(el, name, value) {
    $1995762e80cda67d$var$bindAttribute(el, name, value);
    $1995762e80cda67d$var$setPropertyIfChanged(el, name, value);
}
function $1995762e80cda67d$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $1995762e80cda67d$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($1995762e80cda67d$var$isBooleanAttr(name)) value = name;
        $1995762e80cda67d$var$setIfChanged(el, name, value);
    }
}
function $1995762e80cda67d$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $1995762e80cda67d$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $1995762e80cda67d$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $1995762e80cda67d$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $1995762e80cda67d$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $1995762e80cda67d$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
var $1995762e80cda67d$var$booleanAttributes = /* @__PURE__ */ new Set([
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "inert",
    "ismap",
    "itemscope",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "selected",
    "shadowrootclonable",
    "shadowrootdelegatesfocus",
    "shadowrootserializable"
]);
function $1995762e80cda67d$var$isBooleanAttr(attrName) {
    return $1995762e80cda67d$var$booleanAttributes.has(attrName);
}
function $1995762e80cda67d$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $1995762e80cda67d$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $1995762e80cda67d$var$getAttributeBinding(el, name, fallback);
}
function $1995762e80cda67d$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $1995762e80cda67d$var$dontAutoEvaluateFunctions(()=>{
            return $1995762e80cda67d$var$evaluate(el, binding.expression);
        });
    }
    return $1995762e80cda67d$var$getAttributeBinding(el, name, fallback);
}
function $1995762e80cda67d$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($1995762e80cda67d$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
function $1995762e80cda67d$var$isCheckbox(el) {
    return el.type === "checkbox" || el.localName === "ui-checkbox" || el.localName === "ui-switch";
}
function $1995762e80cda67d$var$isRadio(el) {
    return el.type === "radio" || el.localName === "ui-radio";
}
// packages/alpinejs/src/utils/debounce.js
function $1995762e80cda67d$var$debounce(func, wait) {
    let timeout;
    return function() {
        const context = this, args = arguments;
        const later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $1995762e80cda67d$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $1995762e80cda67d$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let innerHash;
    let reference = $1995762e80cda67d$var$effect(()=>{
        let outer = outerGet();
        let inner = innerGet();
        if (firstRun) {
            innerSet($1995762e80cda67d$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($1995762e80cda67d$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($1995762e80cda67d$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return ()=>{
        $1995762e80cda67d$var$release(reference);
    };
}
function $1995762e80cda67d$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $1995762e80cda67d$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($1995762e80cda67d$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $1995762e80cda67d$var$stores = {};
var $1995762e80cda67d$var$isReactive = false;
function $1995762e80cda67d$var$store(name, value) {
    if (!$1995762e80cda67d$var$isReactive) {
        $1995762e80cda67d$var$stores = $1995762e80cda67d$var$reactive($1995762e80cda67d$var$stores);
        $1995762e80cda67d$var$isReactive = true;
    }
    if (value === void 0) return $1995762e80cda67d$var$stores[name];
    $1995762e80cda67d$var$stores[name] = value;
    $1995762e80cda67d$var$initInterceptors($1995762e80cda67d$var$stores[name]);
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $1995762e80cda67d$var$stores[name].init();
}
function $1995762e80cda67d$var$getStores() {
    return $1995762e80cda67d$var$stores;
}
// packages/alpinejs/src/binds.js
var $1995762e80cda67d$var$binds = {};
function $1995762e80cda67d$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $1995762e80cda67d$var$applyBindingsObject(name, getBindings());
    else $1995762e80cda67d$var$binds[name] = getBindings;
    return ()=>{};
}
function $1995762e80cda67d$var$injectBindingProviders(obj) {
    Object.entries($1995762e80cda67d$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $1995762e80cda67d$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $1995762e80cda67d$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $1995762e80cda67d$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $1995762e80cda67d$var$datas = {};
function $1995762e80cda67d$var$data(name, callback) {
    $1995762e80cda67d$var$datas[name] = callback;
}
function $1995762e80cda67d$var$injectDataProviders(obj, context) {
    Object.entries($1995762e80cda67d$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $1995762e80cda67d$var$Alpine = {
    get reactive () {
        return $1995762e80cda67d$var$reactive;
    },
    get release () {
        return $1995762e80cda67d$var$release;
    },
    get effect () {
        return $1995762e80cda67d$var$effect;
    },
    get raw () {
        return $1995762e80cda67d$var$raw;
    },
    get transaction () {
        return $1995762e80cda67d$var$transaction;
    },
    version: "3.15.12",
    flushAndStopDeferringMutations: $1995762e80cda67d$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $1995762e80cda67d$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $1995762e80cda67d$var$disableEffectScheduling,
    startObservingMutations: $1995762e80cda67d$var$startObservingMutations,
    stopObservingMutations: $1995762e80cda67d$var$stopObservingMutations,
    setReactivityEngine: $1995762e80cda67d$var$setReactivityEngine,
    onAttributeRemoved: $1995762e80cda67d$var$onAttributeRemoved,
    onAttributesAdded: $1995762e80cda67d$var$onAttributesAdded,
    closestDataStack: $1995762e80cda67d$var$closestDataStack,
    skipDuringClone: $1995762e80cda67d$var$skipDuringClone,
    onlyDuringClone: $1995762e80cda67d$var$onlyDuringClone,
    addRootSelector: $1995762e80cda67d$var$addRootSelector,
    addInitSelector: $1995762e80cda67d$var$addInitSelector,
    setErrorHandler: $1995762e80cda67d$var$setErrorHandler,
    interceptClone: $1995762e80cda67d$var$interceptClone,
    addScopeToNode: $1995762e80cda67d$var$addScopeToNode,
    deferMutations: $1995762e80cda67d$var$deferMutations,
    mapAttributes: $1995762e80cda67d$var$mapAttributes,
    evaluateLater: $1995762e80cda67d$var$evaluateLater,
    interceptInit: $1995762e80cda67d$var$interceptInit,
    initInterceptors: $1995762e80cda67d$var$initInterceptors,
    injectMagics: $1995762e80cda67d$var$injectMagics,
    setEvaluator: $1995762e80cda67d$var$setEvaluator,
    setRawEvaluator: $1995762e80cda67d$var$setRawEvaluator,
    mergeProxies: $1995762e80cda67d$var$mergeProxies,
    extractProp: $1995762e80cda67d$var$extractProp,
    findClosest: $1995762e80cda67d$var$findClosest,
    onElRemoved: $1995762e80cda67d$var$onElRemoved,
    closestRoot: $1995762e80cda67d$var$closestRoot,
    destroyTree: $1995762e80cda67d$var$destroyTree,
    interceptor: $1995762e80cda67d$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $1995762e80cda67d$var$transition,
    setStyles: // INTERNAL
    $1995762e80cda67d$var$setStyles,
    mutateDom: // INTERNAL
    $1995762e80cda67d$var$mutateDom,
    directive: $1995762e80cda67d$var$directive,
    entangle: $1995762e80cda67d$var$entangle,
    throttle: $1995762e80cda67d$var$throttle,
    debounce: $1995762e80cda67d$var$debounce,
    evaluate: $1995762e80cda67d$var$evaluate,
    evaluateRaw: $1995762e80cda67d$var$evaluateRaw,
    initTree: $1995762e80cda67d$var$initTree,
    nextTick: $1995762e80cda67d$var$nextTick,
    prefixed: $1995762e80cda67d$var$prefix,
    prefix: $1995762e80cda67d$var$setPrefix,
    plugin: $1995762e80cda67d$var$plugin,
    magic: $1995762e80cda67d$var$magic,
    store: $1995762e80cda67d$var$store,
    start: $1995762e80cda67d$var$start,
    clone: $1995762e80cda67d$var$clone,
    cloneNode: // INTERNAL
    $1995762e80cda67d$var$cloneNode,
    // INTERNAL
    bound: $1995762e80cda67d$var$getBinding,
    $data: $1995762e80cda67d$var$scope,
    watch: $1995762e80cda67d$var$watch,
    walk: $1995762e80cda67d$var$walk,
    data: $1995762e80cda67d$var$data,
    bind: $1995762e80cda67d$var$bind2
};
var $1995762e80cda67d$var$alpine_default = $1995762e80cda67d$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $1995762e80cda67d$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $1995762e80cda67d$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $1995762e80cda67d$var$isBooleanAttr2 = /* @__PURE__ */ $1995762e80cda67d$var$makeMap($1995762e80cda67d$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $1995762e80cda67d$var$EMPTY_OBJ = Object.freeze({});
var $1995762e80cda67d$var$EMPTY_ARR = Object.freeze([]);
var $1995762e80cda67d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $1995762e80cda67d$var$hasOwn = (val, key)=>$1995762e80cda67d$var$hasOwnProperty.call(val, key);
var $1995762e80cda67d$var$isArray = Array.isArray;
var $1995762e80cda67d$var$isMap = (val)=>$1995762e80cda67d$var$toTypeString(val) === "[object Map]";
var $1995762e80cda67d$var$isString = (val)=>typeof val === "string";
var $1995762e80cda67d$var$isSymbol = (val)=>typeof val === "symbol";
var $1995762e80cda67d$var$isObject = (val)=>val !== null && typeof val === "object";
var $1995762e80cda67d$var$objectToString = Object.prototype.toString;
var $1995762e80cda67d$var$toTypeString = (value)=>$1995762e80cda67d$var$objectToString.call(value);
var $1995762e80cda67d$var$toRawType = (value)=>{
    return $1995762e80cda67d$var$toTypeString(value).slice(8, -1);
};
var $1995762e80cda67d$var$isIntegerKey = (key)=>$1995762e80cda67d$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $1995762e80cda67d$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $1995762e80cda67d$var$camelizeRE = /-(\w)/g;
var $1995762e80cda67d$var$camelize = $1995762e80cda67d$var$cacheStringFunction((str)=>{
    return str.replace($1995762e80cda67d$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $1995762e80cda67d$var$hyphenateRE = /\B([A-Z])/g;
var $1995762e80cda67d$var$hyphenate = $1995762e80cda67d$var$cacheStringFunction((str)=>str.replace($1995762e80cda67d$var$hyphenateRE, "-$1").toLowerCase());
var $1995762e80cda67d$var$capitalize = $1995762e80cda67d$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $1995762e80cda67d$var$toHandlerKey = $1995762e80cda67d$var$cacheStringFunction((str)=>str ? `on${$1995762e80cda67d$var$capitalize(str)}` : ``);
var $1995762e80cda67d$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $1995762e80cda67d$var$targetMap = /* @__PURE__ */ new WeakMap();
var $1995762e80cda67d$var$effectStack = [];
var $1995762e80cda67d$var$activeEffect;
var $1995762e80cda67d$var$ITERATE_KEY = Symbol("iterate");
var $1995762e80cda67d$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $1995762e80cda67d$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $1995762e80cda67d$var$effect2(fn, options = $1995762e80cda67d$var$EMPTY_OBJ) {
    if ($1995762e80cda67d$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $1995762e80cda67d$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $1995762e80cda67d$var$stop(effect3) {
    if (effect3.active) {
        $1995762e80cda67d$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $1995762e80cda67d$var$uid = 0;
function $1995762e80cda67d$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$1995762e80cda67d$var$effectStack.includes(effect3)) {
            $1995762e80cda67d$var$cleanup(effect3);
            try {
                $1995762e80cda67d$var$enableTracking();
                $1995762e80cda67d$var$effectStack.push(effect3);
                $1995762e80cda67d$var$activeEffect = effect3;
                return fn();
            } finally{
                $1995762e80cda67d$var$effectStack.pop();
                $1995762e80cda67d$var$resetTracking();
                $1995762e80cda67d$var$activeEffect = $1995762e80cda67d$var$effectStack[$1995762e80cda67d$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $1995762e80cda67d$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $1995762e80cda67d$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $1995762e80cda67d$var$shouldTrack = true;
var $1995762e80cda67d$var$trackStack = [];
function $1995762e80cda67d$var$pauseTracking() {
    $1995762e80cda67d$var$trackStack.push($1995762e80cda67d$var$shouldTrack);
    $1995762e80cda67d$var$shouldTrack = false;
}
function $1995762e80cda67d$var$enableTracking() {
    $1995762e80cda67d$var$trackStack.push($1995762e80cda67d$var$shouldTrack);
    $1995762e80cda67d$var$shouldTrack = true;
}
function $1995762e80cda67d$var$resetTracking() {
    const last = $1995762e80cda67d$var$trackStack.pop();
    $1995762e80cda67d$var$shouldTrack = last === void 0 ? true : last;
}
function $1995762e80cda67d$var$track(target, type, key) {
    if (!$1995762e80cda67d$var$shouldTrack || $1995762e80cda67d$var$activeEffect === void 0) return;
    let depsMap = $1995762e80cda67d$var$targetMap.get(target);
    if (!depsMap) $1995762e80cda67d$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($1995762e80cda67d$var$activeEffect)) {
        dep.add($1995762e80cda67d$var$activeEffect);
        $1995762e80cda67d$var$activeEffect.deps.push(dep);
        if ($1995762e80cda67d$var$activeEffect.options.onTrack) $1995762e80cda67d$var$activeEffect.options.onTrack({
            effect: $1995762e80cda67d$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $1995762e80cda67d$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $1995762e80cda67d$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $1995762e80cda67d$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $1995762e80cda67d$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$1995762e80cda67d$var$isArray(target)) {
                    add2(depsMap.get($1995762e80cda67d$var$ITERATE_KEY));
                    if ($1995762e80cda67d$var$isMap(target)) add2(depsMap.get($1995762e80cda67d$var$MAP_KEY_ITERATE_KEY));
                } else if ($1995762e80cda67d$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$1995762e80cda67d$var$isArray(target)) {
                    add2(depsMap.get($1995762e80cda67d$var$ITERATE_KEY));
                    if ($1995762e80cda67d$var$isMap(target)) add2(depsMap.get($1995762e80cda67d$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($1995762e80cda67d$var$isMap(target)) add2(depsMap.get($1995762e80cda67d$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $1995762e80cda67d$var$isNonTrackableKeys = /* @__PURE__ */ $1995762e80cda67d$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $1995762e80cda67d$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($1995762e80cda67d$var$isSymbol));
var $1995762e80cda67d$var$get2 = /* @__PURE__ */ $1995762e80cda67d$var$createGetter();
var $1995762e80cda67d$var$readonlyGet = /* @__PURE__ */ $1995762e80cda67d$var$createGetter(true);
var $1995762e80cda67d$var$arrayInstrumentations = /* @__PURE__ */ $1995762e80cda67d$var$createArrayInstrumentations();
function $1995762e80cda67d$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $1995762e80cda67d$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$1995762e80cda67d$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($1995762e80cda67d$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $1995762e80cda67d$var$pauseTracking();
            const res = $1995762e80cda67d$var$toRaw(this)[key].apply(this, args);
            $1995762e80cda67d$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $1995762e80cda67d$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $1995762e80cda67d$var$shallowReadonlyMap : $1995762e80cda67d$var$readonlyMap : shallow ? $1995762e80cda67d$var$shallowReactiveMap : $1995762e80cda67d$var$reactiveMap).get(target)) return target;
        const targetIsArray = $1995762e80cda67d$var$isArray(target);
        if (!isReadonly && targetIsArray && $1995762e80cda67d$var$hasOwn($1995762e80cda67d$var$arrayInstrumentations, key)) return Reflect.get($1995762e80cda67d$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($1995762e80cda67d$var$isSymbol(key) ? $1995762e80cda67d$var$builtInSymbols.has(key) : $1995762e80cda67d$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $1995762e80cda67d$var$track(target, "get", key);
        if (shallow) return res;
        if ($1995762e80cda67d$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$1995762e80cda67d$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($1995762e80cda67d$var$isObject(res)) return isReadonly ? $1995762e80cda67d$var$readonly(res) : $1995762e80cda67d$var$reactive2(res);
        return res;
    };
}
var $1995762e80cda67d$var$set2 = /* @__PURE__ */ $1995762e80cda67d$var$createSetter();
function $1995762e80cda67d$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $1995762e80cda67d$var$toRaw(value);
            oldValue = $1995762e80cda67d$var$toRaw(oldValue);
            if (!$1995762e80cda67d$var$isArray(target) && $1995762e80cda67d$var$isRef(oldValue) && !$1995762e80cda67d$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $1995762e80cda67d$var$isArray(target) && $1995762e80cda67d$var$isIntegerKey(key) ? Number(key) < target.length : $1995762e80cda67d$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $1995762e80cda67d$var$toRaw(receiver)) {
            if (!hadKey) $1995762e80cda67d$var$trigger(target, "add", key, value);
            else if ($1995762e80cda67d$var$hasChanged(value, oldValue)) $1995762e80cda67d$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $1995762e80cda67d$var$deleteProperty(target, key) {
    const hadKey = $1995762e80cda67d$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $1995762e80cda67d$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $1995762e80cda67d$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$1995762e80cda67d$var$isSymbol(key) || !$1995762e80cda67d$var$builtInSymbols.has(key)) $1995762e80cda67d$var$track(target, "has", key);
    return result;
}
function $1995762e80cda67d$var$ownKeys(target) {
    $1995762e80cda67d$var$track(target, "iterate", $1995762e80cda67d$var$isArray(target) ? "length" : $1995762e80cda67d$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $1995762e80cda67d$var$mutableHandlers = {
    get: $1995762e80cda67d$var$get2,
    set: $1995762e80cda67d$var$set2,
    deleteProperty: $1995762e80cda67d$var$deleteProperty,
    has: $1995762e80cda67d$var$has,
    ownKeys: $1995762e80cda67d$var$ownKeys
};
var $1995762e80cda67d$var$readonlyHandlers = {
    get: $1995762e80cda67d$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $1995762e80cda67d$var$toReactive = (value)=>$1995762e80cda67d$var$isObject(value) ? $1995762e80cda67d$var$reactive2(value) : value;
var $1995762e80cda67d$var$toReadonly = (value)=>$1995762e80cda67d$var$isObject(value) ? $1995762e80cda67d$var$readonly(value) : value;
var $1995762e80cda67d$var$toShallow = (value)=>value;
var $1995762e80cda67d$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $1995762e80cda67d$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $1995762e80cda67d$var$toRaw(target);
    const rawKey = $1995762e80cda67d$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $1995762e80cda67d$var$track(rawTarget, "get", key);
    !isReadonly && $1995762e80cda67d$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $1995762e80cda67d$var$getProto(rawTarget);
    const wrap = isShallow ? $1995762e80cda67d$var$toShallow : isReadonly ? $1995762e80cda67d$var$toReadonly : $1995762e80cda67d$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $1995762e80cda67d$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $1995762e80cda67d$var$toRaw(target);
    const rawKey = $1995762e80cda67d$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $1995762e80cda67d$var$track(rawTarget, "has", key);
    !isReadonly && $1995762e80cda67d$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $1995762e80cda67d$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $1995762e80cda67d$var$track($1995762e80cda67d$var$toRaw(target), "iterate", $1995762e80cda67d$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $1995762e80cda67d$var$add(value) {
    value = $1995762e80cda67d$var$toRaw(value);
    const target = $1995762e80cda67d$var$toRaw(this);
    const proto = $1995762e80cda67d$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $1995762e80cda67d$var$trigger(target, "add", value, value);
    }
    return this;
}
function $1995762e80cda67d$var$set$1(key, value) {
    value = $1995762e80cda67d$var$toRaw(value);
    const target = $1995762e80cda67d$var$toRaw(this);
    const { has: has2, get: get3 } = $1995762e80cda67d$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $1995762e80cda67d$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $1995762e80cda67d$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $1995762e80cda67d$var$trigger(target, "add", key, value);
    else if ($1995762e80cda67d$var$hasChanged(value, oldValue)) $1995762e80cda67d$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $1995762e80cda67d$var$deleteEntry(key) {
    const target = $1995762e80cda67d$var$toRaw(this);
    const { has: has2, get: get3 } = $1995762e80cda67d$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $1995762e80cda67d$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $1995762e80cda67d$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $1995762e80cda67d$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $1995762e80cda67d$var$clear() {
    const target = $1995762e80cda67d$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $1995762e80cda67d$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $1995762e80cda67d$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $1995762e80cda67d$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $1995762e80cda67d$var$toRaw(target);
        const wrap = isShallow ? $1995762e80cda67d$var$toShallow : isReadonly ? $1995762e80cda67d$var$toReadonly : $1995762e80cda67d$var$toReactive;
        !isReadonly && $1995762e80cda67d$var$track(rawTarget, "iterate", $1995762e80cda67d$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $1995762e80cda67d$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $1995762e80cda67d$var$toRaw(target);
        const targetIsMap = $1995762e80cda67d$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $1995762e80cda67d$var$toShallow : isReadonly ? $1995762e80cda67d$var$toReadonly : $1995762e80cda67d$var$toReactive;
        !isReadonly && $1995762e80cda67d$var$track(rawTarget, "iterate", isKeyOnly ? $1995762e80cda67d$var$MAP_KEY_ITERATE_KEY : $1995762e80cda67d$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $1995762e80cda67d$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$1995762e80cda67d$var$capitalize(type)} operation ${key}failed: target is readonly.`, $1995762e80cda67d$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $1995762e80cda67d$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $1995762e80cda67d$var$get$1(this, key);
        },
        get size () {
            return $1995762e80cda67d$var$size(this);
        },
        has: $1995762e80cda67d$var$has$1,
        add: $1995762e80cda67d$var$add,
        set: $1995762e80cda67d$var$set$1,
        delete: $1995762e80cda67d$var$deleteEntry,
        clear: $1995762e80cda67d$var$clear,
        forEach: $1995762e80cda67d$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $1995762e80cda67d$var$get$1(this, key, false, true);
        },
        get size () {
            return $1995762e80cda67d$var$size(this);
        },
        has: $1995762e80cda67d$var$has$1,
        add: $1995762e80cda67d$var$add,
        set: $1995762e80cda67d$var$set$1,
        delete: $1995762e80cda67d$var$deleteEntry,
        clear: $1995762e80cda67d$var$clear,
        forEach: $1995762e80cda67d$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $1995762e80cda67d$var$get$1(this, key, true);
        },
        get size () {
            return $1995762e80cda67d$var$size(this, true);
        },
        has (key) {
            return $1995762e80cda67d$var$has$1.call(this, key, true);
        },
        add: $1995762e80cda67d$var$createReadonlyMethod("add"),
        set: $1995762e80cda67d$var$createReadonlyMethod("set"),
        delete: $1995762e80cda67d$var$createReadonlyMethod("delete"),
        clear: $1995762e80cda67d$var$createReadonlyMethod("clear"),
        forEach: $1995762e80cda67d$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $1995762e80cda67d$var$get$1(this, key, true, true);
        },
        get size () {
            return $1995762e80cda67d$var$size(this, true);
        },
        has (key) {
            return $1995762e80cda67d$var$has$1.call(this, key, true);
        },
        add: $1995762e80cda67d$var$createReadonlyMethod("add"),
        set: $1995762e80cda67d$var$createReadonlyMethod("set"),
        delete: $1995762e80cda67d$var$createReadonlyMethod("delete"),
        clear: $1995762e80cda67d$var$createReadonlyMethod("clear"),
        forEach: $1995762e80cda67d$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $1995762e80cda67d$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $1995762e80cda67d$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $1995762e80cda67d$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $1995762e80cda67d$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$1995762e80cda67d$var$mutableInstrumentations, $1995762e80cda67d$var$readonlyInstrumentations, $1995762e80cda67d$var$shallowInstrumentations, $1995762e80cda67d$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $1995762e80cda67d$var$createInstrumentations();
function $1995762e80cda67d$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $1995762e80cda67d$var$shallowReadonlyInstrumentations : $1995762e80cda67d$var$shallowInstrumentations : isReadonly ? $1995762e80cda67d$var$readonlyInstrumentations : $1995762e80cda67d$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($1995762e80cda67d$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $1995762e80cda67d$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $1995762e80cda67d$var$createInstrumentationGetter(false, false)
};
var $1995762e80cda67d$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $1995762e80cda67d$var$createInstrumentationGetter(true, false)
};
function $1995762e80cda67d$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $1995762e80cda67d$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $1995762e80cda67d$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $1995762e80cda67d$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $1995762e80cda67d$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $1995762e80cda67d$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $1995762e80cda67d$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $1995762e80cda67d$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $1995762e80cda67d$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $1995762e80cda67d$var$targetTypeMap($1995762e80cda67d$var$toRawType(value));
}
function $1995762e80cda67d$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $1995762e80cda67d$var$createReactiveObject(target, false, $1995762e80cda67d$var$mutableHandlers, $1995762e80cda67d$var$mutableCollectionHandlers, $1995762e80cda67d$var$reactiveMap);
}
function $1995762e80cda67d$var$readonly(target) {
    return $1995762e80cda67d$var$createReactiveObject(target, true, $1995762e80cda67d$var$readonlyHandlers, $1995762e80cda67d$var$readonlyCollectionHandlers, $1995762e80cda67d$var$readonlyMap);
}
function $1995762e80cda67d$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$1995762e80cda67d$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $1995762e80cda67d$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $1995762e80cda67d$var$toRaw(observed) {
    return observed && $1995762e80cda67d$var$toRaw(observed["__v_raw"]) || observed;
}
function $1995762e80cda67d$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$1995762e80cda67d$var$magic("nextTick", ()=>$1995762e80cda67d$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$1995762e80cda67d$var$magic("dispatch", (el)=>$1995762e80cda67d$var$dispatch.bind($1995762e80cda67d$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$1995762e80cda67d$var$magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let getter = ()=>{
            let value;
            evaluate2((i)=>value = i);
            return value;
        };
        let unwatch = $1995762e80cda67d$var$watch(getter, callback);
        cleanup2(unwatch);
    });
// packages/alpinejs/src/magics/$store.js
$1995762e80cda67d$var$magic("store", $1995762e80cda67d$var$getStores);
// packages/alpinejs/src/magics/$data.js
$1995762e80cda67d$var$magic("data", (el)=>$1995762e80cda67d$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$1995762e80cda67d$var$magic("root", (el)=>$1995762e80cda67d$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$1995762e80cda67d$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $1995762e80cda67d$var$mergeProxies($1995762e80cda67d$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $1995762e80cda67d$var$getArrayOfRefObject(el) {
    let refObjects = [];
    $1995762e80cda67d$var$findClosest(el, (i)=>{
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $1995762e80cda67d$var$globalIdMemo = {};
function $1995762e80cda67d$var$findAndIncrementId(name) {
    if (!$1995762e80cda67d$var$globalIdMemo[name]) $1995762e80cda67d$var$globalIdMemo[name] = 0;
    return ++$1995762e80cda67d$var$globalIdMemo[name];
}
function $1995762e80cda67d$var$closestIdRoot(el, name) {
    return $1995762e80cda67d$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $1995762e80cda67d$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $1995762e80cda67d$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$1995762e80cda67d$var$magic("id", (el, { cleanup: cleanup2 })=>(name, key = null)=>{
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return $1995762e80cda67d$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, ()=>{
            let root = $1995762e80cda67d$var$closestIdRoot(el, name);
            let id = root ? root._x_ids[name] : $1995762e80cda67d$var$findAndIncrementId(name);
            return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
    });
$1995762e80cda67d$var$interceptClone((from, to)=>{
    if (from._x_id) to._x_id = from._x_id;
});
function $1995762e80cda67d$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(()=>{
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$1995762e80cda67d$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$1995762e80cda67d$var$warnMissingPluginMagic("Focus", "focus", "focus");
$1995762e80cda67d$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $1995762e80cda67d$var$warnMissingPluginMagic(name, magicName, slug) {
    $1995762e80cda67d$var$magic(magicName, (el)=>$1995762e80cda67d$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$1995762e80cda67d$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.setWithModifiers;
        let releaseEntanglement = $1995762e80cda67d$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$1995762e80cda67d$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $1995762e80cda67d$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $1995762e80cda67d$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $1995762e80cda67d$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $1995762e80cda67d$var$mutateDom(()=>{
        $1995762e80cda67d$var$skipDuringClone(()=>{
            placeInDom(clone2, target, modifiers);
            $1995762e80cda67d$var$initTree(clone2);
        })();
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $1995762e80cda67d$var$getTarget(expression);
        $1995762e80cda67d$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(()=>$1995762e80cda67d$var$mutateDom(()=>{
            clone2.remove();
            $1995762e80cda67d$var$destroyTree(clone2);
        }));
});
var $1995762e80cda67d$var$teleportContainerDuringClone = document.createElement("div");
function $1995762e80cda67d$var$getTarget(expression) {
    let target = $1995762e80cda67d$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $1995762e80cda67d$var$teleportContainerDuringClone;
    })();
    if (!target) $1995762e80cda67d$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $1995762e80cda67d$var$handler = ()=>{};
$1995762e80cda67d$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$1995762e80cda67d$var$directive("ignore", $1995762e80cda67d$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$1995762e80cda67d$var$directive("effect", $1995762e80cda67d$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($1995762e80cda67d$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $1995762e80cda67d$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $1995762e80cda67d$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $1995762e80cda67d$var$camelCase2(event);
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("passive")) options.passive = modifiers[modifiers.indexOf("passive") + 1] !== "false";
    handler4 = $1995762e80cda67d$var$addDebounceOrThrottle(modifiers, handler4);
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if (event === "submit") handler4 = wrapHandler(handler4, (next, e)=>{
        if (e.target._x_pendingModelUpdates) e.target._x_pendingModelUpdates.forEach((fn)=>fn());
        next(e);
    });
    if ($1995762e80cda67d$var$isKeyEvent(event) || $1995762e80cda67d$var$isClickEvent(event)) handler4 = wrapHandler(handler4, (next, e)=>{
        if ($1995762e80cda67d$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $1995762e80cda67d$var$addDebounceOrThrottle(modifiers, handler4) {
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $1995762e80cda67d$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $1995762e80cda67d$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $1995762e80cda67d$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $1995762e80cda67d$var$throttle(handler4, wait);
    }
    return handler4;
}
function $1995762e80cda67d$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $1995762e80cda67d$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $1995762e80cda67d$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $1995762e80cda67d$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $1995762e80cda67d$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $1995762e80cda67d$var$isClickEvent(event) {
    return [
        "contextmenu",
        "click",
        "mouse"
    ].some((i)=>event.includes(i));
}
function $1995762e80cda67d$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture",
            "self",
            "away",
            "outside",
            "passive",
            "preserve-scroll",
            "blur",
            "change",
            "lazy"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $1995762e80cda67d$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $1995762e80cda67d$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $1995762e80cda67d$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($1995762e80cda67d$var$isClickEvent(e.type)) return false;
            if ($1995762e80cda67d$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $1995762e80cda67d$var$keyToModifiers(key) {
    if (!key) return [];
    key = $1995762e80cda67d$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "comma": ",",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$1995762e80cda67d$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = $1995762e80cda67d$var$findClosest(el, (element)=>element !== el);
    let evaluateGet = $1995762e80cda67d$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $1995762e80cda67d$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $1995762e80cda67d$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $1995762e80cda67d$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($1995762e80cda67d$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $1995762e80cda67d$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    let hasChangeModifier = modifiers.includes("change") || modifiers.includes("lazy");
    let hasBlurModifier = modifiers.includes("blur");
    let hasEnterModifier = modifiers.includes("enter");
    let hasExplicitEventModifiers = hasChangeModifier || hasBlurModifier || hasEnterModifier;
    let removeListener;
    if ($1995762e80cda67d$var$isCloning) removeListener = ()=>{};
    else if (hasExplicitEventModifiers) {
        let listeners = [];
        let syncValue = (e)=>setValue($1995762e80cda67d$var$getInputValue(el, modifiers, e, getValue()));
        if (hasChangeModifier) listeners.push($1995762e80cda67d$var$on(el, "change", modifiers, syncValue));
        if (hasBlurModifier) {
            listeners.push($1995762e80cda67d$var$on(el, "blur", modifiers, syncValue));
            if (el.form) {
                let form = el.form;
                let syncCallback = ()=>syncValue({
                        target: el
                    });
                if (!form._x_pendingModelUpdates) form._x_pendingModelUpdates = [];
                form._x_pendingModelUpdates.push(syncCallback);
                cleanup2(()=>{
                    if (form._x_pendingModelUpdates) form._x_pendingModelUpdates.splice(form._x_pendingModelUpdates.indexOf(syncCallback), 1);
                });
            }
        }
        if (hasEnterModifier) listeners.push($1995762e80cda67d$var$on(el, "keydown", modifiers, (e)=>{
            if (e.key === "Enter") syncValue(e);
        }));
        removeListener = ()=>listeners.forEach((remove)=>remove());
    } else {
        let event = el.tagName.toLowerCase() === "select" || [
            "checkbox",
            "radio"
        ].includes(el.type) ? "change" : "input";
        removeListener = $1995762e80cda67d$var$on(el, event, modifiers, (e)=>{
            setValue($1995762e80cda67d$var$getInputValue(el, modifiers, e, getValue()));
        });
    }
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || $1995762e80cda67d$var$isCheckbox(el) && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) setValue($1995762e80cda67d$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $1995762e80cda67d$var$on(el.form, "reset", [], (e)=>{
            $1995762e80cda67d$var$nextTick(()=>el._x_model && el._x_model.set($1995762e80cda67d$var$getInputValue(el, modifiers, {
                    target: el
                }, getValue())));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        },
        setWithModifiers: $1995762e80cda67d$var$addDebounceOrThrottle(modifiers, setValue)
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        $1995762e80cda67d$var$mutateDom(()=>{
            if ($1995762e80cda67d$var$isCheckbox(el)) {
                if (Array.isArray(value)) el.checked = value.some((val)=>val == el.value);
                else el.checked = !!value;
            } else if ($1995762e80cda67d$var$isRadio(el)) {
                if (typeof value === "boolean") el.checked = $1995762e80cda67d$var$safeParseBoolean(el.value) === value;
                else el.checked = el.value == value;
            } else $1995762e80cda67d$var$bind(el, "value", value);
        });
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $1995762e80cda67d$var$getInputValue(el, modifiers, event, currentValue) {
    return $1995762e80cda67d$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if ($1995762e80cda67d$var$isCheckbox(el)) {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $1995762e80cda67d$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $1995762e80cda67d$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$1995762e80cda67d$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $1995762e80cda67d$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $1995762e80cda67d$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            let newValue;
            if ($1995762e80cda67d$var$isRadio(el)) {
                if (event.target.checked) newValue = event.target.value;
                else newValue = currentValue;
            } else newValue = event.target.value;
            if (modifiers.includes("number")) return $1995762e80cda67d$var$safeParseNumber(newValue);
            else if (modifiers.includes("boolean")) return $1995762e80cda67d$var$safeParseBoolean(newValue);
            else if (modifiers.includes("trim")) return newValue.trim();
            else return newValue;
        }
    });
}
function $1995762e80cda67d$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $1995762e80cda67d$var$isNumeric2(number) ? number : rawValue;
}
function $1995762e80cda67d$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $1995762e80cda67d$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $1995762e80cda67d$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$1995762e80cda67d$var$directive("cloak", (el)=>queueMicrotask(()=>$1995762e80cda67d$var$mutateDom(()=>el.removeAttribute($1995762e80cda67d$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$1995762e80cda67d$var$addInitSelector(()=>`[${$1995762e80cda67d$var$prefix("init")}]`);
$1995762e80cda67d$var$directive("init", $1995762e80cda67d$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$1995762e80cda67d$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $1995762e80cda67d$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$1995762e80cda67d$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $1995762e80cda67d$var$mutateDom(()=>{
                el.innerHTML = value ?? "";
                el._x_ignoreSelf = true;
                $1995762e80cda67d$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$1995762e80cda67d$var$mapAttributes($1995762e80cda67d$var$startingWith(":", $1995762e80cda67d$var$into($1995762e80cda67d$var$prefix("bind:"))));
var $1995762e80cda67d$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3, cleanup: cleanup2 })=>{
    if (!value) {
        let bindingProviders = {};
        $1995762e80cda67d$var$injectBindingProviders(bindingProviders);
        let getBindings = $1995762e80cda67d$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $1995762e80cda67d$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $1995762e80cda67d$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $1995762e80cda67d$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $1995762e80cda67d$var$mutateDom(()=>$1995762e80cda67d$var$bind(el, value, result, modifiers));
        }));
    cleanup2(()=>{
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$1995762e80cda67d$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$1995762e80cda67d$var$directive("bind", $1995762e80cda67d$var$handler2);
function $1995762e80cda67d$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$1995762e80cda67d$var$addRootSelector(()=>`[${$1995762e80cda67d$var$prefix("data")}]`);
$1995762e80cda67d$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($1995762e80cda67d$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $1995762e80cda67d$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $1995762e80cda67d$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $1995762e80cda67d$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $1995762e80cda67d$var$injectMagics(data2, el);
    let reactiveData = $1995762e80cda67d$var$reactive(data2);
    $1995762e80cda67d$var$initInterceptors(reactiveData);
    let undo = $1995762e80cda67d$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $1995762e80cda67d$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $1995762e80cda67d$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$1995762e80cda67d$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $1995762e80cda67d$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$1995762e80cda67d$var$isCloning) return false;
    if ($1995762e80cda67d$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$1995762e80cda67d$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $1995762e80cda67d$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $1995762e80cda67d$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $1995762e80cda67d$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $1995762e80cda67d$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$1995762e80cda67d$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $1995762e80cda67d$var$parseForExpression(expression);
    let evaluateItems = $1995762e80cda67d$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $1995762e80cda67d$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_lookup = /* @__PURE__ */ new Map();
    effect3(()=>$1995762e80cda67d$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        el._x_lookup.forEach((el2)=>$1995762e80cda67d$var$mutateDom(()=>{
                $1995762e80cda67d$var$destroyTree(el2);
                el2.remove();
            }));
        delete el._x_lookup;
    });
});
function $1995762e80cda67d$var$refreshScope(scope2) {
    return (newScope)=>{
        Object.entries(newScope).forEach(([key, value])=>{
            scope2[key] = value;
        });
    };
}
function $1995762e80cda67d$var$loop(templateEl, iteratorNames, evaluateItems, evaluateKey) {
    evaluateItems((items)=>{
        if ($1995762e80cda67d$var$isNumeric3(items)) items = Array.from({
            length: items
        }, (_, i)=>i + 1);
        if (items === void 0 || items === null) items = [];
        if (items instanceof Set) items = Array.from(items);
        if (items instanceof Map) items = Array.from(items);
        let oldLookup = templateEl._x_lookup;
        let lookup = /* @__PURE__ */ new Map();
        templateEl._x_lookup = lookup;
        let hasStringKeys = $1995762e80cda67d$var$isObject2(items);
        let scopeEntries = Object.entries(items).map(([index, item])=>{
            if (!hasStringKeys) index = parseInt(index);
            let scope2 = $1995762e80cda67d$var$getIterationScopeVariables(iteratorNames, item, index, items);
            let key;
            evaluateKey((innerKey)=>{
                if (typeof innerKey === "object") $1995762e80cda67d$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
                if (oldLookup.has(innerKey)) {
                    lookup.set(innerKey, oldLookup.get(innerKey));
                    oldLookup.delete(innerKey);
                }
                key = innerKey;
            }, {
                scope: {
                    index: index,
                    ...scope2
                }
            });
            return [
                key,
                scope2
            ];
        });
        $1995762e80cda67d$var$mutateDom(()=>{
            oldLookup.forEach((el)=>{
                $1995762e80cda67d$var$destroyTree(el);
                el.remove();
            });
            let added = /* @__PURE__ */ new Set();
            let prev = templateEl;
            scopeEntries.forEach(([key, scope2])=>{
                if (lookup.has(key)) {
                    let el = lookup.get(key);
                    el._x_refreshXForScope(scope2);
                    if (prev.nextElementSibling !== el) {
                        if (prev.nextElementSibling) el.replaceWith(prev.nextElementSibling);
                        prev.after(el);
                    }
                    prev = el;
                    if (el._x_currentIfEl) {
                        if (el.nextElementSibling !== el._x_currentIfEl) prev.after(el._x_currentIfEl);
                        prev = el._x_currentIfEl;
                    }
                    return;
                }
                if (templateEl.content.children.length > 1) $1995762e80cda67d$var$warn("x-for templates require a single root element, additional elements will be ignored.", templateEl);
                let clone2 = document.importNode(templateEl.content, true).firstElementChild;
                let reactiveScope = $1995762e80cda67d$var$reactive(scope2);
                $1995762e80cda67d$var$addScopeToNode(clone2, reactiveScope, templateEl);
                clone2._x_refreshXForScope = $1995762e80cda67d$var$refreshScope(reactiveScope);
                lookup.set(key, clone2);
                added.add(clone2);
                prev.after(clone2);
                prev = clone2;
            });
            $1995762e80cda67d$var$skipDuringClone(()=>added.forEach((clone2)=>$1995762e80cda67d$var$initTree(clone2)))();
        });
    });
}
function $1995762e80cda67d$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $1995762e80cda67d$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $1995762e80cda67d$var$isNumeric3(subject) {
    return typeof subject !== "object" && !isNaN(subject);
}
function $1995762e80cda67d$var$isObject2(subject) {
    return typeof subject === "object" && !Array.isArray(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $1995762e80cda67d$var$handler3() {}
$1995762e80cda67d$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $1995762e80cda67d$var$closestRoot(el);
    if (!root) return;
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$1995762e80cda67d$var$directive("ref", $1995762e80cda67d$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$1995762e80cda67d$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $1995762e80cda67d$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $1995762e80cda67d$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $1995762e80cda67d$var$addScopeToNode(clone2, {}, el);
        $1995762e80cda67d$var$mutateDom(()=>{
            el.after(clone2);
            $1995762e80cda67d$var$skipDuringClone(()=>$1995762e80cda67d$var$initTree(clone2))();
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $1995762e80cda67d$var$mutateDom(()=>{
                $1995762e80cda67d$var$destroyTree(clone2);
                clone2.remove();
            });
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$1995762e80cda67d$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$1995762e80cda67d$var$setIdRoot(el, name));
});
$1995762e80cda67d$var$interceptClone((from, to)=>{
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$1995762e80cda67d$var$mapAttributes($1995762e80cda67d$var$startingWith("@", $1995762e80cda67d$var$into($1995762e80cda67d$var$prefix("on:"))));
$1995762e80cda67d$var$directive("on", $1995762e80cda67d$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $1995762e80cda67d$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $1995762e80cda67d$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$1995762e80cda67d$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$1995762e80cda67d$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$1995762e80cda67d$var$warnMissingPluginDirective("Focus", "trap", "focus");
$1995762e80cda67d$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $1995762e80cda67d$var$warnMissingPluginDirective(name, directiveName, slug) {
    $1995762e80cda67d$var$directive(directiveName, (el)=>$1995762e80cda67d$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$1995762e80cda67d$var$alpine_default.setEvaluator($1995762e80cda67d$var$normalEvaluator);
$1995762e80cda67d$var$alpine_default.setRawEvaluator($1995762e80cda67d$var$normalRawEvaluator);
$1995762e80cda67d$var$alpine_default.setReactivityEngine({
    reactive: $1995762e80cda67d$var$reactive2,
    effect: $1995762e80cda67d$var$effect2,
    release: $1995762e80cda67d$var$stop,
    raw: $1995762e80cda67d$var$toRaw
});
var $1995762e80cda67d$export$b7ee041e4ad2afec = $1995762e80cda67d$var$alpine_default;
// packages/alpinejs/builds/module.js
var $1995762e80cda67d$export$2e2bcd8739ae039 = $1995762e80cda67d$export$b7ee041e4ad2afec;


var $c363029048efb161$exports = {};
$c363029048efb161$exports = JSON.parse('{"header":"Heiliges ARAM-am-Abend Gesetzbuch (HAramAAGB)","paragraphs":[{"header":"Anwendbarkeit","sections":["Dieses Gesetz findet abweichend nachfolgender Bestimmungen Anwendung im Spielmodus All-Random-All-Mid (ARAM).","Karte des Spielmodus ist Howling Abyss. Im Falle der Verf\xfcgbarkeit anderer Karten wird der Spielmodus auf diesen ausgetragen. Das gilt insbesondere, wenn die Karte durch Zufall bestimmt wird.","In F\xe4llen eines ARAM-Clash\'s sind die nachfolgenden Regeln in der Hinsicht entsprechend anwendbar, sodass der Sieg die oberste Priorit\xe4t ist.","Ein ARAM ist wichtiger, als ein Ranked."]},{"header":"Anzahl der ARAM","sections":["Generell sind drei ARAM zu spielen. Die zu verwendende Bezeichnung ist: ARAM-am-Abend (AAA).","Liegen triftige Gr\xfcnde vor, die die Durchf\xfchrung des AAA nach Abs. 1 verhindern, kann die Anzahl der ARAM auf eins reduziert werden. Zwei ARAM sind grunds\xe4tzlich verboten.","Die f\xfcr Abs. 1 und 2 zu verwendende Anzahl der ARAM ist zum Modulus 3 zu berechnen.","Gespielte ARAM im Sinne des Abs. 1 sind nur solche, die nicht geremaked wurden.","Dieser Vorschrift steht ein Tageswechsel nicht entgegen.","Tritt eine weitere Person dem AAA hinzu, so ist die Anzahl der ARAM nach Abs. 1 von vorne zu berechnen. Dies gilt auch f\xfcr die Personen, welche bereits die ARAM gespielt haben. In diesem Fall sind jedoch drei ARAM zu spielen. Abs. 3 und \xa7 3 Abs. 2 gelten entsprechend.","Wird eine unzul\xe4ssige Anzahl an ARAM gespielt ist \xa7 9 anzuwenden. Die Ausnahmen nach \xa7 3 sind zu beachten."]},{"header":"Ausnahmen","sections":["In verzweifelten F\xe4llen werden in \xdcbereinkunft beteiligter Personen ARAM gespielt und durch eine gemeinsame Bekundung durch ein \u201EARGHHHHHHHHH\u201C, welches klar und deutlich zu erkennen sein muss, kenntlich gemacht, bis ein Sieg errungen werden kann. \xa7 2 Abs. 3 ist nicht anzuwenden.","Im Falle des \xa7 2 Abs. 2 Satz 2 dieser Vorschrift ist, die Bereitschaft nur zwei ARAM spielen zu wollen offenkundig zu machen. Diese Vorschrift ist nur in Ausnahmef\xe4llen anzuwenden. Dies ist insbesondere dann gegeben, wenn den Teilnehmern wenig Zeit aufgrund morgendlicher Verpflichtungen zur Verf\xfcgung steht. Sanktionen sind nicht zu verh\xe4ngen. \xa7 2 Abs. 3 ist entsprechend anzuwenden."]},{"header":"Summoner Spells","sections":["Die AAA-Summoner-Spells sind Flash und Snowball.","Von dieser Regel darf nur durch ein Mehrheitsvotum oder durch Pick des Champions \u201EYuumi\u201C abgewichen werden. Satz 2 ist f\xfcr \xe4hnliche Champions entsprechend anzuwenden.","Nichtbefolgung zieht das Schreiben von \u201Creport [Spieler] for lack of snowball\u201D durch verbleibende Gruppenmitglieder im f\xfcr das gegnerische Team sichtbaren Kommunikationskanal nach sich. \xa7 9 ist anzuwenden","In Ausnahmef\xe4llen kann anstelle von Flash ein vergleichbarer Summoner-Spell gew\xe4hlt werden. Dies gilt nur in F\xe4llen, bei denen die Effizienz des Picks durch den anderen Summoner-Spell erh\xf6ht werden kann. Insbesondere kann Flash durch Ghost ersetzt werden."]},{"header":"Finish","sections":["M\xf6glichkeiten zum siegreichen Beenden des ARAM d\xfcrfen nur in Anspruch genommen werden, wenn ansonsten die Gefahr der eigenen Niederlage nach \xfcbereinstimmender Einsch\xe4tzung der beteiligten Personen unabwendbar erscheint.","Genannte Bedingung muss nicht erf\xfcllt sein, wenn die eigenen Nexust\xfcrme bereits zerst\xf6rt wurden. (Nomos-Regel).","Aus Zeitmangel darf von Abs. (1) abgewichen werden.","\xa7 5 findet keine Anwendung in F\xe4llen des \xa7 1 Abs. 3."]},{"header":"ARAM-Gott","sections":["Den Weisungen einer Person mit mindestens 2000 ARAM-Spielen (ARAM-Gott) ist stets Folge zu leisten.","Der ARAM-Gott ist befugt eine Reduzierung oder Erh\xf6hung der ARAM gem\xe4\xdf \xa7 3 anzuordnen.","Bei Uneinigkeiten unter ARAM-G\xf6ttern, hat der ARAM-Gott recht, der mehr ARAM gespielt hat.","Bei Gleichstand des Abs. 3 entscheidet der Spieler mit der h\xf6heren ARAM-Winrate. Ist durch Rundung auf die zweite Nachkommastelle der Gleichstand nicht entschieden, so entscheidet ein M\xfcnzwurf."]},{"header":"Kerngedanke","sections":["Der Kerngedanke des AAA lautet: \u201EEinfach Rein!\u201C.","Getroffene Schneeb\xe4lle m\xfcssen grunds\xe4tzlich reaktiviert werden, wenn die M\xf6glichkeit des gegnerischen Todes besteht (captain-Gesetz).","In F\xe4llen des \xa7 1 Abs. 3 ist eine Abw\xe4gung des Abs. 2 zwingend durchzuf\xfchren. Von dieser Regelung darf abgewichen werden, wenn Bedingungen gem\xe4\xdf \xa7 4 Abs. 2 zutreffen."]},{"header":"Weitere Bestimmungen","sections":["Dem ARAM darf weder im Vorhinein gedodged, noch darf es w\xe4hrend des Spiels surrendert werden. Dies gilt nicht, wenn triftige Gr\xfcnde angef\xfchrt werden k\xf6nnen.","Ein Tod, der nach bestem Wissen und Gewissen als Execute gewertet werden wird, ist zul\xe4ssig. Dies gilt nicht, wenn die begr\xfcndete Annahme besteht, dass der Tod unmittelbar zur Niederlage des ARAM f\xfchren wird, insbesondere in F\xe4llen des \xa7 1 Abs. 3. Der ARAM-Gott ist befugt vorr\xfcbergehend die Zul\xe4ssigkeit der Executes zu unterbinden.","Die Regeln dieses Gesetzes finden auf Spielmodi, welche den Namen \\"ARAM\\" enthalten entsprechende Anwendung.","Flash kann genutzt werden, um einen Heal zu erlangen. Dies gilt nicht in F\xe4llen des \xa7 1 Abs. 3.","Eine Liste, welche die l\xe4ngsten ARAM auflistet, wird erstellt. Dabei sind Uhrzeit des Beginns und des Endes entscheidend. Die Zeit wird mittels des Clients berechnet.","Regelm\xe4\xdfige Teilnehmer des AAA sollen in ihrem League-Status die Anzahl ihrer ARAM angeben. Dies gilt nicht bei besonderen Anl\xe4ssen."]},{"header":"Sanktionen","sections":["Nichtbefolgung einer Regel wird mit zehn Liegest\xfctzen geahndet.","\xdcber die Durchf\xfchrung der Strafe wacht der in \xa7 10 Abs. 2 genannte Personenkreis.","In Ausnahef\xe4llen kann die Strafe durch Mehrheitsbeschluss erlassen werden."]},{"header":"Inkrafttreten, Bindung","sections":["Dieses Gesetz tritt durch seine Verk\xfcndung im Teamspeak in Kraft. Es ist von CodeHat auf entsprechender Webseite zug\xe4nglich zu machen.","S\xe4mtliche nachfolgenden Personen haben das Gesetz ratifiziert (pseudonymisiert: Jxxxxx, CxxxHxx, cxxxxxx0000, Ixxxxxxxx, Nxxxx00, Jxxxxx, Kxxxxx Bxxx).","Die in Abs. 2 genannten Personen haben diesem Gesetz stets Folge zu leisten.","Treten zu den in Abs. 2 genannten Personen eine weitere Person in einem Spiel hinzu, so wird diese Person auf dieses Gesetz hingewiesen."]}],"footer":"Gezeichnet\\nDer Elohell-Pr\xe4sident\\nCaptain Teemo","version":"03/11/2025"}');


const $46d02a182fbb34fb$var$rules = ()=>({
        rules: (0, (/*@__PURE__*/$parcel$interopDefault($c363029048efb161$exports)))
    });
var $46d02a182fbb34fb$export$2e2bcd8739ae039 = $46d02a182fbb34fb$var$rules;


globalThis.Alpine = (0, $1995762e80cda67d$export$2e2bcd8739ae039);
(0, $1995762e80cda67d$export$2e2bcd8739ae039).data('rules', (0, $46d02a182fbb34fb$export$2e2bcd8739ae039));
(0, $1995762e80cda67d$export$2e2bcd8739ae039).start();


//# sourceMappingURL=app.3363653c.js.map
